import { createStore } from 'vuex'
// import createPersistedState from "vuex-persistedstate"
import Cookies from 'js-cookie'
import router from '@/router'

// const persistedState = createPersistedState({
//   paths: ['userData']
// })

export default createStore({
  //plugins: [persistedState],
  state: {
    userData: null,
    credentialSecretModal: null,
    userGroupUsersModal: null,
    userGroupUserRemove: null,
    userGroupDelete: null,
    authCredentialDelete: null,
    userGroupPermissionsModal: null,
    automationJobModal: null,
    users: null
  },
  getters: {
    isAdmin(state) {
      if (state.userData == null) return false;
      if (state.userData.user.usertags.includes('admin')) {
        return true;
      } else {
        return false;
      }
    }
  },
  mutations: {
    setUserData(state, userData) {
      Cookies.set('userData', JSON.stringify(userData), { expires: 1 });
      state.userData = userData;
    },
    logout(state) {
      Cookies.remove('userData');
      state.userData = null;
      router.push('/')
    },
    setCredentialSecretModal(state, authCredential) {
      state.credentialSecretModal = authCredential;
    },
    setUserGroupUsersModal(state, userGroup) {
      state.userGroupUsersModal = userGroup;
    },
    setUserGroupPermissionsModal(state, userGroup) {
      state.userGroupPermissionsModal = userGroup;
    },
    setUserGroupDelete(state, userGroup) {
      state.userGroupDelete = userGroup;
    },
    setUserGroupUserRemove(state, data) {
      state.userGroupUserRemove = data;
    },
    setAuthCredentialDelete(state, authCredential) {
      state.authCredentialDelete = authCredential;
    },
    setAutomationJobModal(state, automationJob) {
      state.automationJobModal = automationJob;
    },
    setUsers(state, users) {
      state.users = users;
    }
  }
});
